/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-non-null-assertion

import { SalespersonTotalDto, SalespersonTotalValue } from '@gh/builder-shared-data';

export type SalespersonTotal = SalespersonTotalDto;
export type SalespersonTotalItem = {
  [index: string]: any;
};

export const salespersonTotalRowKey: string = 'lbl_dashboard_param';
export const salespersonTotalFromDto = (dto: SalespersonTotalDto): SalespersonTotalItem[] => {
  const items: SalespersonTotalItem[] = [];
  const rowTitles: string[] = ['lbl_no_of_salespeople', 'lbl_avg_no_per_franchise'];

  dto.values.forEach((value: SalespersonTotalValue, valueIndex: number) => {
    const values: SalespersonTotalItem = {};
    dto.headerValues
      .forEach((headerValue: string, headerIndex: number) => {
        values[salespersonTotalRowKey] = rowTitles[valueIndex];
        values[headerValue] = value.values[headerIndex];
      });

    items.push(values);
  });

  return items;
};
